class ObjectSlider {
    constructor() {
        this.wrapper = null;
        this.wrapperSlider = null;
        this.images = null;
        this.hovers = null;
        this.isAnim = false;
        this.currentSlide = null;
    }

    init(options) {
        this.wrapper = options.wrapper;
        this.wrapperSlider = this.wrapper.querySelector('.j-object-slider');
        this.images = Array.from(this.wrapperSlider.querySelectorAll('.j-object-slider-image'));
        this.hovers = Array.from(this.wrapperSlider.querySelectorAll('.j-object-slider-hover'));
        this.dots = Array.from(this.wrapperSlider.querySelectorAll('.j-object-slider-dot'));
        this.objectHover = this.wrapper.querySelector('.j-hover');

        if (!this.wrapper.hasAttribute('init')) {
            this.wrapper.setAttribute('init', 'true');

            if (this.images.length && this.hovers.length) {
                this._bindEvents();
            }

            if (this.objectHover) {
                this._bindEventsHover();
            }
        }
    }

    /**
     * Обрабатывает события
     * @private
     */
    _bindEvents() {
        this.hovers.forEach((item) => {
            item.addEventListener('mouseover', () => {
                if (this.isAnim) {
                    return;
                }

                this._playAnimation(item);
            });
        });
    }

    /**
     * Обрабатывает событие наведения
     * @private
     */
    _bindEventsHover() {
        this.objectHover.addEventListener('mouseenter', () => {
            this.wrapper.classList.add('is-hover');
        });

        this.objectHover.addEventListener('mouseleave', () => {
            this.wrapper.classList.remove('is-hover');
        });
    }

    /**
     * Проверяет находится ли мышка над элементом с которым нужно проиграть анимацию
     * @private
     */
    _getHoverPosition() {
        this.isAnim = false;

        const arrHovers = document.querySelectorAll(':hover');
        let lastItem = null;

        if (arrHovers.length) {
            lastItem = arrHovers[arrHovers.length - 1];
        }

        // Если элемент на который наводим является наводимым (j-object-slider-hover)
        // и он отличается от предыдущего наводимого элемента
        if (lastItem && lastItem.classList.contains('j-object-slider-hover') && lastItem !== this.currentSlide) {
            this._playAnimation(lastItem);
        }
    }

    /**
     * Запускает анимацию
     * @param {node} item - элемент над которым запускаем анимацию
     * @private
     */
    _playAnimation(item) {
        const id = item.dataset.id;
        const currentImage = this.images.find((image) => {
            return image.dataset.id === id;
        });
        const currentDot = this.dots.find((dot) => {
            return dot.dataset.id === id;
        });

        if (currentImage && currentDot) {
            this.isAnim = true;

            setTimeout(() => {
                this._removeStaticClass(this.images);
                currentImage.classList.add('is-static');

                this._getHoverPosition();
            }, 1000);

            this.currentSlide = item;

            this._removeActiveClass(this.images);
            this._removeActiveClass(this.dots);

            currentImage.classList.add('is-active');
            currentDot.classList.add('is-active');
        }
    }

    /**
     * Убирает класс активации с картинок в слайдере
     * @param {object} arr - массив всех картинок
     * @private
     */
    _removeActiveClass(arr) {
        arr.forEach((item) => {
            item.classList.remove('is-active');
        });
    }

    _removeStaticClass(arr) {
        arr.forEach((item) => {
            item.classList.remove('is-static');
        });
    }
}

export default ObjectSlider;
